window.PimV2QuantityTotal = {
  init(options) {
    const quantityInputId = options && options.quantityInputId ? options.quantityInputId : '';
    const quantityInputEl = document.getElementById(quantityInputId);

    if (quantityInputEl != null) {
      quantityInputEl.addEventListener('change', function() {
        window.PimV2QuantityTotal.updateTotalAddCart();
      });
    }
  },

  updateTotalAddCart() {
    window.calculatePimV2Pricing();
  }
};

window.updateTotalAddCart =
    window.PimV2QuantityTotal.updateTotalAddCart;
